import React from 'react';
import { UiKit } from '@datavant/uikit';
import { VStack } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const VeradigmModal = (props: { onClose: () => void; isOpen: boolean }) => {
    const ModalBody = (
        <VStack width={'100%'} alignItems={'left'}>
            <UiKit.Text.BodyRegularBold>
                To move forward with Autofulfill setup, please provide the following information to
                requestmanager@datavant.com by email:
            </UiKit.Text.BodyRegularBold>
            <UiKit.Chakra.UnorderedList>
                <UiKit.Chakra.ListItem>
                    <UiKit.Text.BodyRegular>Allscripts Practice Account Number</UiKit.Text.BodyRegular>
                </UiKit.Chakra.ListItem>
                <UiKit.Chakra.ListItem>
                    <UiKit.Text.BodyRegular>Practice Name</UiKit.Text.BodyRegular>
                </UiKit.Chakra.ListItem>
                <UiKit.Chakra.ListItem>
                    <UiKit.Text.BodyRegular>Practice Contact Name</UiKit.Text.BodyRegular>
                </UiKit.Chakra.ListItem>
                <UiKit.Chakra.ListItem>
                    <UiKit.Text.BodyRegular>Practice Contact Telephone</UiKit.Text.BodyRegular>
                </UiKit.Chakra.ListItem>
                <UiKit.Chakra.ListItem>
                    <UiKit.Text.BodyRegular>Practice Contact Email</UiKit.Text.BodyRegular>
                </UiKit.Chakra.ListItem>
                <UiKit.Chakra.ListItem>
                    <UiKit.Text.BodyRegular>Practice Product</UiKit.Text.BodyRegular>
                    <UiKit.Chakra.UnorderedList styleType="circle">
                        <UiKit.Chakra.ListItem>
                            <UiKit.Text.BodyRegular>
                                Veradigm Practice Management (Formerly Allscripts Practice Management)
                            </UiKit.Text.BodyRegular>
                        </UiKit.Chakra.ListItem>
                        <UiKit.Chakra.ListItem>
                            <UiKit.Text.BodyRegular>
                                Veradigm EHR (Formerly Allscripts Professional EHR)
                            </UiKit.Text.BodyRegular>
                        </UiKit.Chakra.ListItem>
                        <UiKit.Chakra.ListItem>
                            <UiKit.Text.BodyRegular>Sunrise EHR</UiKit.Text.BodyRegular>
                        </UiKit.Chakra.ListItem>
                        <UiKit.Chakra.ListItem>
                            <UiKit.Text.BodyRegular>Touchworks EHR</UiKit.Text.BodyRegular>
                        </UiKit.Chakra.ListItem>
                    </UiKit.Chakra.UnorderedList>
                </UiKit.Chakra.ListItem>
                <UiKit.Chakra.ListItem>
                    <UiKit.Text.BodyRegular>Unity License Key (If known)</UiKit.Text.BodyRegular>
                </UiKit.Chakra.ListItem>
            </UiKit.Chakra.UnorderedList>
            <UiKit.Text.BodyRegular>
                Our team will reach out with next steps once we are ready to proceed with implementation.
                Thank you!
            </UiKit.Text.BodyRegular>
        </VStack>
    );

    const ModalFooter = (
        <UiKit.Chakra.VStack>
            <UiKit.Chakra.HStack w={'full'} justifyContent={'flex-end'} spacing={UiKit.consistency.buffer}>
                <UiKit.Button.Cancel text={'Close'} onClick={props.onClose} />
            </UiKit.Chakra.HStack>
        </UiKit.Chakra.VStack>
    );

    return (
        <UiKit.Modal
            title={'Continue Autofulfill Set Up'}
            bodyFragment={ModalBody}
            footerFragment={ModalFooter}
            onClose={props.onClose}
            isOpen={props.isOpen}
            size={'2xl'}
            fullScreen={false}
        />
    );
};
